import moment from "moment-timezone";

// Keep in sync with the backend's getReportFileName
// (Starcruises-CMS-Server/src/shared/report-downloads/report-download-file-name.ts) -
// same label map, same timezone, same id suffix - so the friendly name
// shown in Activity Logs always matches the actual stored file's basename.
export const MODULE_LABELS = {
  entertainment_sales_report: "Onboard Purchase Sales Report",
  entertainment_summary_report: "Onboard Purchase Summary Report",
  shorex_sales_report: "Shorex Sales Report",
  shorex_summary_report: "Shorex Summary Report",
};

// Fallback only - used when a row has no timezone (requested before that
// field existed), never for a normal request.
const REPORT_FILE_NAME_TZ = "Asia/Kuala_Lumpur";

export const getReportFileName = (moduleName, createdAt, id, timezone) => {
  const reportLabel = MODULE_LABELS[moduleName] || moduleName;
  const safeLabel = reportLabel.replace(/[^a-zA-Z0-9]+/g, "_");
  const timestamp = moment(createdAt)
    .tz(timezone || REPORT_FILE_NAME_TZ)
    .format("YYYYMMDD_HHmmss");
  return `${safeLabel}_${timestamp}_${id}.xlsx`;
};
